import { render, staticRenderFns } from "./specific_week_date.vue?vue&type=template&id=2bfdf671&scoped=true&lang=pug&"
import script from "./specific_week_date.vue?vue&type=script&lang=js&"
export * from "./specific_week_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdf671",
  null
  
)

export default component.exports